var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDownloadModel = function SvgIconDownloadModel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505665",
    fillRule: "evenodd",
    d: "M12.002 3.5c.587 0 1.062.476 1.062 1.062v8.592l2.966-2.966a1.063 1.063 0 0 1 1.502 1.503l-4.028 4.028c-.83.83-2.175.83-3.005 0l-4.03-4.03a1.062 1.062 0 1 1 1.503-1.502l2.967 2.967V4.562c0-.586.476-1.062 1.063-1.062Zm-7.44 11.688a1.062 1.062 0 0 0-2.125 0v2.125A3.187 3.187 0 0 0 5.626 20.5h12.75a3.187 3.187 0 0 0 3.187-3.187v-2.125a1.062 1.062 0 0 0-2.125 0v2.125c0 .586-.476 1.062-1.062 1.062H5.625a1.062 1.062 0 0 1-1.063-1.062v-2.125Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDownloadModel;